module.exports = __webpack_public_path__ + "static/img/hg_img.0562dd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hg_img.png
// module id = IsTz
// module chunks = 1